import React, { useState, useEffect } from "react";
import { Modal, Input, Switch, Button, Space, Form, message } from "antd";
import { configApi } from "../../../services/api";

export default function CreateConfigModal({ visible, onCancel, onCreated, configType, tenantSchema }) {
  const [form] = Form.useForm();
  const [saving, setSaving] = useState(false);
  const isAlias = configType === "alias";

  useEffect(() => {
    if (visible) form.resetFields();
  }, [visible, form]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setSaving(true);
      const payload = {
        name: values.name.trim(),
        config_type: configType,
        is_active: values.is_active !== undefined ? values.is_active : true,
        ...(isAlias
          ? { alias_name: values.alias_name || "" }
          : { value: values.value || "" }),
      };
      const res = await configApi.createConfig(tenantSchema, payload);
      message.success(`Created "${values.name}" successfully`);
      onCreated(res.data);
      onCancel();
    } catch (err) {
      if (err?.errorFields) return; // form validation error, don't show message
      message.error(err.response?.data?.error || "Failed to create");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      title={
        <div className="flex items-center gap-2.5">
          <span className="text-[15px] font-semibold">
            Add {isAlias ? "Alias" : "Config"}
          </span>
        </div>
      }
      open={visible}
      onCancel={onCancel}
      width={480}
      destroyOnClose
      footer={
        <Space>
          <Button onClick={onCancel}>Cancel</Button>
          <Button type="primary" onClick={handleSubmit} loading={saving}>
            Create
          </Button>
        </Space>
      }
    >
      <Form
        form={form}
        layout="vertical"
        className="mt-2"
        initialValues={{ is_active: true }}
      >
        <Form.Item
          label="Name"
          name="name"
          rules={[{ required: true, message: "Name is required" }]}
        >
          <Input placeholder="e.g. feature_flag_dark_mode" autoFocus />
        </Form.Item>

        {isAlias ? (
          <Form.Item label="Alias Value" name="alias_name">
            <Input.TextArea
              rows={3}
              placeholder='e.g. {"key": "value"} or plain text'
            />
          </Form.Item>
        ) : (
          <Form.Item label="Value" name="value">
            <Input.TextArea
              rows={3}
              placeholder="e.g. true / 30 / some text"
            />
          </Form.Item>
        )}

        <Form.Item label="Active" name="is_active" valuePropName="checked">
          <Switch />
        </Form.Item>
      </Form>
    </Modal>
  );
}
